<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-select
                    show-default-option
                    :options="form.tipos"
                    :validations="validations.tipoId"
                    label="Tipo"
                    text-field="nome"
                    v-model="model.tipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    show-default-option
                    :options="form.servicos"
                    :validations="validations.servicoId"
                    label="Serviço"
                    text-field="nome"
                    v-model="model.servicoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    v-model="model.nome"
                    uppercase
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    mixins: [ repository, stringCase, object, error ],
    props: {
        id: { type: Number }
    },
    data: () => ({
        repositories: {
            setor: null,
        },
        form: {
            tipos: [],
            servicos: [],
        },
        model: {
            tipoId: null,
            servicoId: null,
            nome: null,
        },
    }),
    computed: {
        validations() {

            return {
                tipoId: { required: true },
                servicoId: { required: true },
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
            }
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.setor.edit(this.id)
                : this.repositories.setor.create()

            request
                .then(({ data }) => {

                    Object.assign(this.form, data.form)
                    Object.assign(this.model, data.model || {})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.setor.update(this.id, this.prepareData())
                        : this.repositories.setor.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            return this.camelObjectKeysToSnakeRecursive(this.clone(this.model))
        },
    },
    created() {

        this.repositories.setor = this.getConectaSusRepository('cadastro.estabelecimento.setor')

        this.load()
    },
}
</script>